import React from 'react';
import { FormField } from '../../FormField/FormField';
import { BranchesSelect } from '../../BranchesSelect/BranchesSelect';
import { ReservationType } from '../../../types/reservationType';
import { ReservationFormFieldProps } from '../types';

interface Props extends ReservationFormFieldProps {
  isModifying: boolean;
  showRequiredFields: boolean;
  reservationType: ReservationType | undefined;
  employeeBranchIds: string[] | undefined;
  employeeBranchesLoading: boolean;
}

/** The branch of the reservation. */
export const BranchField = ({
  form,
  setFormFields,
  validationErrors,
  isModifying,
  showRequiredFields,
  reservationType,
  employeeBranchIds,
  employeeBranchesLoading,
}: Props) => {
  return (
    <FormField
      elementId='reservation-branch'
      labelTitle='Sucursal'
      required={showRequiredFields}
      error={validationErrors?.branch}
    >
      {isModifying ? (
        <BranchesSelect
          id='reservation-branch'
          isSingle
          onlyAuthUserBranches
          error={validationErrors?.branch}
          value={form?.branch?.id}
          filterByBranchIds={reservationType?.hasAssignedUsers ? (employeeBranchIds ?? []) : undefined}
          disabled={!!reservationType?.hasAssignedUsers && (!form.user?.id || employeeBranchesLoading)}
          onChange={(branch) => setFormFields({ branch })}
        />
      ) : (
        <p>{form?.branch?.name}</p>
      )}
    </FormField>
  );
};
